/**
 * Copy text to clipboard and optionally run a short-lived success callback.
 * @param {string} text
 * @param {{ onSuccess?: () => void, onError?: (err: unknown) => void }} [opts]
 */
export async function copyText(text, { onSuccess, onError } = {}) {
  if (!text) {
    onError?.(new Error("Nothing to copy."));
    return false;
  }
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "fixed";
      el.style.opacity = "0";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    onSuccess?.();
    return true;
  } catch (err) {
    onError?.(err);
    return false;
  }
}
